export const convertToLogVolume = (linearVolume: number) => {
    return Math.pow(linearVolume, 2.0);
};
